import React, { useContext,useEffect } from 'react';
import { useParams,useLocation,useHistory} from 'react-router-dom';
import { Contextone } from './Context';
import styled from 'styled-components';
import MahuaDesi from "../images/mahuadesi.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { logAnalyticsEvent } from "./Script.js";


const VideoPlayer = () => {
    const countercontext = useContext(Contextone);
    const {moviename,encoded} = useParams();

    const decodeComponent = () => {
        if (!encoded || typeof encoded !== "string") {
            console.error("Invalid or missing encoded value:", encoded);
            return "";
        }
    
        try {
            return atob(encoded); 
        } catch (error) {
            console.error("Decoding failed for encoded value:", encoded, error);
            return "";
        }
    };
      
    let [id, type_id, video_type, upcoming_type] = decodeComponent(encoded).split('-');
    const history = useHistory();
    const location = useLocation();
    const { url_video, video_lib } = location.state || {};
    let vidSplit = moviename.split("/");
    let vidName = vidSplit.pop();


    const vUrl = `https://iframe.mediadelivery.net/embed/${video_lib}/${url_video}?autoplay=true&loop=false&muted=false&preload=true&responsive=true`
	const handleIframeLoad = () => {
    logAnalyticsEvent('videoplay', {
      videoname : vidName,
      timestamp: new Date().toISOString(),
  });
  };

  const handleBeforeUnload = (event) => {
    event.preventDefault(); 
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      logAnalyticsEvent('videoended', {
        name : vidName,
        timestamp: new Date().toISOString(),
      });
    };
  }, []);

    return ( 
        <>
    {url_video &&  video_lib ?
      <div>
        <div className="top-left-button">
        <button onClick={() => history.goBack()} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#000', cursor: 'pointer' }}>
            <FontAwesomeIcon icon={faArrowLeft} style={{ color: 'white' }} />
          </button>
          {countercontext.isDomain === 'mahuaplay.ottsnap.in' && <img src = {MahuaDesi} height = "67px"/>}
        </div>
        <div style={{ height: '100vh' }}>
            <iframe
              id="framePlayer"
              width="100%"
              height="99%"
              src={vUrl}
              allow="autoplay"
              allowFullScreen
              onLoad={handleIframeLoad}
            />
          </div>
      </div>:
      <div>
        {id && type_id && parseInt(video_type) === 0 ? history.push('/') : history.push(`/home/${moviename}/${encoded}`)}
      </div>
    }
    </>
    );
};

export default VideoPlayer;